import CardModal, { CardModalProps } from '@anm/components/modals/CardModal';
import { FC } from 'react';
import styled from 'styled-components';
import EscOnBlock from '@anm/components/KeyDownOnBlock';
import ProjectPreview, { ProjectPreviewProps } from './ProjectPreview';

export type ProjectPreviewModalProps = CardModalProps &
  Omit<ProjectPreviewProps, 'closeModal'> & {
    onModalClose: () => void;
  };

const CardModalWrapper = styled(CardModal)`
  background-color: transparent;
  padding: 5px;
`;
const ProjectPreviewModal: FC<ProjectPreviewModalProps> = ({ onModalClose, ...previewProps }) => (
  <EscOnBlock onEsc={onModalClose}>
    <CardModalWrapper cardSettings={{ isPadding: false, variant: 'transparent' }} onModalClose={onModalClose}>
      <ProjectPreview {...previewProps} closeModal={onModalClose} />
    </CardModalWrapper>
  </EscOnBlock>
);

export default ProjectPreviewModal;
